import Vue from 'vue'
import store from "../store"
var uniqid = require('uniqid');
import moment from "moment";
import { _ } from 'core-js';
import { isNil } from 'lodash';
var a = {
    data: function () {
        return {}
    },
    methods: {
        toggle_sidebar: async function (sidebar_name) {
            if (!_.isNull(this.$store.state.global_sidebar)) {
                Vue.set(this.$store.state, "global_sidebar", null);
            } else {
                Vue.set(this.$store.state, "global_sidebar", sidebar_name);
            }
        },
        is_active_sidebar: function (sidebar_name) {
            if (this.$store.state.global_sidebar == sidebar_name) {
                return true;
            }
            return false;
        },
        generate_id: function () {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        },
        moment: function (date) {
            moment.locale('fr')
            if (_.isUndefined(date)) {
                return moment();
            }
            return moment(date);
        },
        uniqid: function () {
            return uniqid();
        },
        utils_getValidationState: function ({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        utils_get_cookies: function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return null;
        },
        utils_set_cookies: function (cname, cvalue, c_minutes_duration) {
            var date = new Date();
            date.setTime(date.getTime() + (c_minutes_duration * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        utils_delete_cookies: function (name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        },
        utils_get_config_item: function (key1, key2) {
            if (_.isNull(store.state.configs)) {
                return false;
            }
            if (_.isUndefined(store.state.configs[key1])) {
                return null;
            }
            if (!_.isUndefined(key1)) {
                if (!_.isUndefined(store.state.configs[key1][key2])) {
                    return store.state.configs[key1][key2];
                }
            }
            return store.state.configs[key1];
        },
        utils_get_config_message: function (key) {
            if (_.isNull(store.state.configs.messages)) {
                return "";
            }
            if (_.isUndefined(store.state.configs.messages[key])) {
                return "";
            }
            return store.state.configs.messages[key];
        },
        utils_show_global_alert: function (data) {
            Vue.set(store.state.global_alert, "show", false);
            Vue.set(store.state.global_alert, "show", true);
            Vue.set(store.state.global_alert, "message", data);
        },
        utils_show_global_poup: function (text) {
            this.$bvModal.show('notification_modal');
            Vue.set(store.state, "global_popup_message", text);
        },
        utils_close_global_poup: function () {
            this.$bvModal.hide('notification_modal');
            Vue.set(store.state, "global_popup_message", "");
        },
        ajax_params: function (ajax_config, cb) {
            var default_config = {
                url: "",
                show_error: true,
                show_remote_error: true,
                data: {},
                type: "POST",
                dataType: "json",
                retry: 5000,
                max_retry: 0,
                headers: {}
            };
            ajax_config = _.assign(default_config, ajax_config);
            var pic = this.utils_get_cookies("pic");
            if (!_.isNull(pic) && !_.isUndefined(pic)) {
                ajax_config["headers"]["pic"] = pic
            }
            var auth_cookie = this.utils_get_cookies("MUST");
            if (!_.isNull(auth_cookie)) {
                ajax_config["headers"]["authorization"] = "Bissap " + auth_cookie;
            }
            var self = this;
            var max_retry = 0;
            var timeInterval = null;
            return _.assign(ajax_config, {
                complete: function (response) {
                    clearInterval(timeInterval);
                    if (response.status === 200) {
                        if (!_.isUndefined(cb)) {
                            cb(response.status, response.responseJSON);
                        }
                        if (ajax_config.show_remote_error) {
                            if (!_.isUndefined(response.responseJSON)) {
                                if (_.isObject(response.responseJSON)) {
                                    var error_keys = ["error", "unauthorized", "internal_error"];

                                    for (let index = 0; index < error_keys.length; index++) {
                                        const error = error_keys[index];
                                        if (!_.isUndefined(response.responseJSON[error])) {
                                            if (_.isString(response.responseJSON[error])) {
                                                return self.utils_show_global_alert({ text: response.responseJSON[error], type: "danger" });
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    }
                    max_retry += 1;

                    if (!_.isUndefined(cb)) {
                        if (!_.isUndefined(ajax_config.max_retry)) {
                            if (ajax_config.max_retry != 0) {
                                if (ajax_config.retry) {
                                    if (ajax_config.max_retry == max_retry) {
                                        self.show_ajax_message(ajax_config, response);
                                        cb(response.status, null);
                                        return;
                                    }
                                }
                            }
                        }

                        cb(response.status, null);
                    }
                    if (ajax_config.retry) {
                        var that = this;
                        timeInterval = setTimeout(function () {
                            $.ajax(that);
                        }, ajax_config.retry);
                    }
                    self.show_ajax_message(ajax_config, response);
                }
            });
        },
        utils_async_ajax: async function (ajax_config, cb, retry) {
            return $.ajax(this.ajax_params(ajax_config, cb));
        },
        utils_ajax: function (ajax_config, cb, retry) {
            $.ajax(this.ajax_params(ajax_config, cb));
        },
        show_ajax_message: function (ajax_config, response) {
            if (ajax_config.show_error) {
                switch (response.status) {
                    case 401:

                        break;
                    case 500:

                        break;
                    case 0:

                        break;
                    default:

                        break;
                }
                this.utils_show_global_alert({ text: "Une erreur s'est produite", type: "danger" });
            }
        },
        isEmpty: function (el) {
            return _.isEmpty(el);
        },
        isNull: function (el) {
            return _.isNull(el);
        },
        isObject: function (el) {
            return _.isObject(el);
        },
        isArray: function (el) {
            return _.isArray(el);
        },
        utils_set_page_title: function (title) {
            document.title = title + " | MyMTN Web" || "MyMTN Web";
        },
        open_modal: function (id) {
            this.$bvModal.show(id);
        },
        close_modal: function (id) {
            this.$bvModal.hide(id);
        },
        isValidPhone: function (value) {
            let authorized_max_lengths = store.state.settings?.phone_prefixes?.msisdn_length ?? [10];
            const prefixes = store.state.settings?.phone_prefixes?.mtn ?? [];

            let prefixIncluded = prefixes.some((pr) => value.toString().startsWith(pr));
            const lengthOf = value.toString().length;
            return prefixIncluded && authorized_max_lengths.includes(lengthOf);
        },
        // isValidPhone: function (value) {
        //     const prefixes = ['51', '52', '61', '62', '66', '67', '69', '90', '91', '96', '97']
        //     const phone_prefixe = value.toString()[0] + value.toString()[1]
        //     const lengthOf = value.toString().length
        //     return prefixes.includes(phone_prefixe) && lengthOf == 8
        // },
        formatCallDatas(str) {
            if (str === '' || str.trim() == '0FCFA') {
                return '00:00:00'
            } else {
                str = str.replace('Min', ':')
                str = str.replace('M', ':')
                str = str.replace('Sec', '')
                str = str.replace('S',)
                str = str.replace('Hr', ':')
                let arr = str.split(':')
                arr = arr.filter(element => element.trim() !== '' && !isNaN(element) == true);
                for (let i = 0; i < arr.length; i++) {
                    if (parseInt(arr[i].trim()) < 10) {
                        arr[i] = '0' + arr[i].trim()
                    }
                }
                if (arr.length == 1) {
                    return (`00:00:${arr[0].trim()}`).trim()
                } else if (arr.length == 2) {
                    return (`00:${arr[0].trim()}:${arr[1].trim()}`).trim()
                } else if (arr.length == 3) {
                    return (`${arr[0].trim()}:${arr[1].trim()}:${arr[2].trim()}`).trim()
                }
            }
        },
        formatInternetData(data) {
            if (data.trim() === '') {
                return '0 MB'
            } else {
                let arr = data.split('MB')
                if (parseFloat(arr[0].trim()) > 1000) {
                    return (parseFloat(arr[0].trim()) / 1000).toFixed(2) + ' ' + 'GB'
                } else {
                    return data
                }
            }
        },
        dataTableLang() {
            return {
                "decimal": "",
                "emptyTable": "Aucune donnée trouvée",
                "info": "Affichage de l'élément _START_ à _END_ sur _TOTAL_ élément(s)",
                "infoEmpty": "Affichage de l'élément 0 à 0 sur 0 élément",
                "infoFiltered": "(filtré dans un total de _MAX_ éléments)",
                "infoPostFix": "",
                "thousands": ",",
                "lengthMenu": " _MENU_ éléments par page",
                "loadingRecords": "Chargement...",
                "processing": "Traitement...",
                "search": "Rechercher:",
                "zeroRecords": "Aucun élément correspondant trouvé",
                "paginate": {
                    "first": "Premier",
                    "last": "Dernier",
                    "next": "Suivant",
                    "previous": "Précédent"
                },
                "aria": {
                    "sortAscending": ": activer pour trier la colonne par ordre croissant",
                    "sortDescending": ": activer pour trier la colonne par ordre décroissant"
                }
            }
        },
        formatPaymentStatus(oustanding_amount) {
            const shema = {
                unpaid: "Non payée",
                paid: "Payée"
            }
            if (oustanding_amount > 0) {
                return shema['unpaid']
            } else {
                return shema['paid']
            }
        },
        crop_prefix(number) {
            if (!number) {
                return "";
            }

            let output = ""

            if (number.length < 11) {
                output = number;
            } else {
                output = number.toString().startsWith("229")
                    ? number.toString().slice(3)
                    : number;
            }


            if(store.state?.settings?.phone_prefixes?.display_new_format) {
                if(output.length === 8) {
                    output = "01" + output;
                }
            }

            return output;
        }
    }
};
export default a;